import { gql } from "@apollo/client";
import client from "api/client"; // Assuming you have Apollo Client setup

const GET_ATTRIBUTE_OPTIONS = gql`
  query AttributeOptions($attributeCode: String!) {
    attributeOptions(attributeCode: $attributeCode) {
      label
      value
    }
  }
`;

export const fetchAttributeOptions = async (attributeCode: string) => {
  try {
    const { data } = await client.query({
      query: GET_ATTRIBUTE_OPTIONS,
      variables: { attributeCode },
    });

    return data.attributeOptions.map((option: any) => ({
      option_id: option.value,
      value: option.label,
    }));
  } catch (error) {
    console.error("Error fetching attribute options:", error);
    return [];
  }
};
